"use strict";
exports.__esModule = true;
function getKey(keyName, _keyTypetype) {
    return { name: keyName };
}
exports.getKey = getKey;
var CUFF_LINK_WINDOW_PROP = "$$$cuffLink";
var CuffLink = /** @class */ (function () {
    function CuffLink() {
    }
    CuffLink.getRegistry = function () {
        if (!window[CUFF_LINK_WINDOW_PROP]) {
            window[CUFF_LINK_WINDOW_PROP] = new Map();
        }
        return window[CUFF_LINK_WINDOW_PROP];
    };
    CuffLink.register = function (key, thing) {
        this.getRegistry().set(key.name, thing);
    };
    CuffLink.fetch = function (key) {
        var obj = this.getRegistry().get(key.name);
        if (!obj) {
            throw new Error("Unable to fetch " + key.name);
        }
        return obj;
    };
    return CuffLink;
}());
exports.CuffLink = CuffLink;
//# sourceMappingURL=CuffLink.js.map